/* ============================================================
   STRYKE — Shopify Theme JS
   ============================================================ */

/* ══════════════════════════════════════════
   MONEY

   This file is an asset, so it cannot contain
   Liquid and cannot know the active market's
   currency format on its own. window.StrykeMoney
   is published by the cart drawer section, which
   derives the format from Liquid.

   Looked up at call time rather than captured at
   load: these run on user interaction, long after
   both files have parsed, so load order between
   them does not matter.
══════════════════════════════════════════ */
function strykeMoney(cents) {
  if (window.StrykeMoney && window.StrykeMoney.format) {
    return window.StrykeMoney.format(cents);
  }
  return '$' + (cents / 100).toFixed(2);
}

function strykeMoneyWithCurrency(cents) {
  if (window.StrykeMoney) {
    if (window.StrykeMoney.formatWithCurrency) {
      return window.StrykeMoney.formatWithCurrency(cents);
    }
    /* Degrade to the bare format plus the ISO code rather than to
       a hardcoded "$… AUD". Printing the wrong currency is worse
       than printing a slightly redundant one — and that hardcoded
       suffix is exactly what showed "$153.00 AUD" on a 153 LEI
       cart. */
    if (window.StrykeMoney.format) {
      var s   = window.StrykeMoney.format(cents);
      var iso = window.StrykeMoney.currency;
      return (iso && s.indexOf(iso) === -1) ? s + ' ' + iso : s;
    }
  }
  return (cents / 100).toFixed(2);
}

// ── Header: hide on scroll-down, reveal on scroll-up ─────────
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  let lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    const y = window.scrollY;
    if (y > lastY && y > 80) {
      header.classList.add('is-hidden');
    } else if (y < lastY) {
      header.classList.remove('is-hidden');
    }
    lastY = y;
  }, { passive: true });
})();

// ── Mobile nav toggle ─────────────────────────────────────────
(function () {
  const btn       = document.querySelector('.btn-menu');
  const mobileNav = document.querySelector('.site-header__mobile-nav');
  const iconOpen  = document.querySelector('.icon-menu');
  const iconClose = document.querySelector('.icon-close');
  if (!btn || !mobileNav) return;

  btn.addEventListener('click', function () {
    const open = mobileNav.classList.toggle('is-open');
    if (iconOpen)  iconOpen.style.display  = open ? 'none' : 'block';
    if (iconClose) iconClose.style.display = open ? 'block' : 'none';
    btn.setAttribute('aria-expanded', open);
  });

  // Close on nav link click
  mobileNav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      if (iconOpen)  iconOpen.style.display  = 'block';
      if (iconClose) iconClose.style.display = 'none';
      btn.setAttribute('aria-expanded', 'false');
    });
  });
})();

// ── Size selector on product page ─────────────────────────────
(function () {
  const btns = document.querySelectorAll('.size-btn');
  if (!btns.length) return;

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      // Sync hidden variant selector for Shopify
      const size = btn.dataset.size;
      const select = document.querySelector('.product-variant-select');
      if (select) {
        for (let i = 0; i < select.options.length; i++) {
          if (select.options[i].value === size || select.options[i].text === size) {
            select.selectedIndex = i;
            select.dispatchEvent(new Event('change'));
            break;
          }
        }
      }

      // Update ATC button total
      updateATCTotal();
    });
  });
})();

// ── Quantity control on product page ─────────────────────────
(function () {
  const decBtn  = document.querySelector('.qty-dec');
  const incBtn  = document.querySelector('.qty-inc');
  const display = document.querySelector('.qty-value');
  const input   = document.querySelector('.qty-input');
  if (!decBtn || !incBtn || !display) return;

  let qty = 1;

  decBtn.addEventListener('click', function () {
    if (qty > 1) { qty--; update(); }
  });
  incBtn.addEventListener('click', function () {
    qty++;
    update();
  });

  function update() {
    display.textContent = qty;
    if (input) input.value = qty;
    updateATCTotal();
  }
})();

// ── ATC total price display ───────────────────────────────────
function updateATCTotal() {
  const atcBtn    = document.querySelector('.btn-atc');
  const basePrice = parseFloat(atcBtn && atcBtn.dataset.basePrice || '0');
  const qty       = parseInt(document.querySelector('.qty-value')?.textContent || '1');
  const activeSize = document.querySelector('.size-btn.is-active');
  if (!atcBtn || !basePrice) return;

  /* data-base-price is already in the market's currency — Liquid
     divided the market price by 100 — so only the formatting was
     ever wrong here. Back to cents for the formatter, rounded
     because float multiplication lands on 15299.999999999998. */
  const totalCents = Math.round(basePrice * qty * 100);
  const totalText  = strykeMoney(totalCents);

  const sizeLabel = activeSize ? activeSize.dataset.size : '';
  atcBtn.textContent = sizeLabel
    ? `Add to Bag — ${totalText} · ${sizeLabel}`
    : `Add to Bag — ${totalText}`;
}

// ── Smooth scroll for in-page anchors ────────────────────────
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ── Cart Drawer ───────────────────────────────────────────────
(function () {
  const drawer      = document.getElementById('cart-drawer');
  const overlay     = document.getElementById('cart-drawer-overlay');
  const toggleBtn   = document.getElementById('cart-drawer-toggle');
  const closeBtn    = document.getElementById('cart-drawer-close');
  const body        = document.getElementById('cart-drawer-body');
  const footer      = document.getElementById('cart-drawer-footer');
  const totalEl     = document.getElementById('cart-drawer-total');
  const cartCountEl = document.getElementById('cart-count');

  if (!drawer) return;

  /* ── Open / Close ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (overlay)   overlay.addEventListener('click', closeDrawer);

  /* Close on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Fetch & Render Cart ── */
  function fetchCart() {
    body.innerHTML = '<div class="cart-drawer__loading">Loading...</div>';
    footer.style.display = 'none';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {
        body.innerHTML = '<div class="cart-drawer__empty">Could not load cart.</div>';
      });
  }

  function renderCart(cart) {

    /* ── Update header count ── */
    if (cartCountEl) cartCountEl.textContent = cart.item_count;

    /* ══════════════════════════════════════════
       FREE SHIPPING BAR

       The threshold is $88 in AUD cents, but
       /cart.js returns cents in whatever currency
       the market is using. Comparing the two is
       meaningless — a 153 LEI cart (~A$52) read as
       clearing 8800 and announced free shipping
       that checkout would not honour.

       The drawer section marks the bar
       is-market-hidden outside AUD. Checking that
       class rather than the currency keeps the rule
       in one place: change the market gate there
       and this follows.
    ══════════════════════════════════════════ */
    var threshold = 8800; /* $88.00 in AUD cents */
    var fillEl    = document.getElementById('cart-shipping-fill');
    var textEl    = document.getElementById('cart-shipping-text');
    var barEl     = document.querySelector('.cart-drawer__shipping-bar');
    var barOff    = barEl && barEl.classList.contains('is-market-hidden');

    if (fillEl && textEl && !barOff) {
      var remaining  = threshold - cart.total_price;
      var percentage = Math.min((cart.total_price / threshold) * 100, 100);
      fillEl.style.width = percentage + '%';

      if (remaining > 0) {
        textEl.innerHTML = 'Add <span>' + strykeMoney(remaining) + '</span> more for free shipping';
      } else {
        textEl.innerHTML = '<span>You\'ve unlocked free shipping!</span>';
      }
    }

    /* ── Empty cart ── */
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">Your cart is empty</div>';
      footer.style.display = 'none';
      return;
    }

    /* ── Render items ── */
    var html = '';
    cart.items.forEach(function (item) {
      var image = item.image
        ? '<img class="cart-item__image" src="' + item.image + '" alt="' + item.title + '">'
        : '<div class="cart-item__image"></div>';

      html += '<div class="cart-item" data-key="' + item.key + '">';
      html += image;
      html += '<div class="cart-item__details">';
      html += '<div class="cart-item__name">' + item.product_title + '</div>';
      if (item.variant_title) {
        html += '<div class="cart-item__variant">' + item.variant_title + '</div>';
      }
      html += '<div class="cart-item__price">' + strykeMoney(item.final_line_price) + '</div>';
      html += '<div class="cart-item__actions">';
      html += '<div class="cart-item__qty">';
      html += '<button class="qty-drawer-dec" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button class="qty-drawer-inc" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove item">';
      html += '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>';
      html += '</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    body.innerHTML = html;

    /* ── Total ──
       money_with_currency, which carries the currency itself.
       The old hardcoded " AUD" suffix is gone: it was the one
       thing that stayed wrong even once the symbol was fixed. */
    totalEl.textContent = strykeMoneyWithCurrency(cart.total_price);
    footer.style.display = 'flex';

    /* ── Bind quantity & remove buttons ── */
    body.querySelectorAll('.qty-drawer-dec, .qty-drawer-inc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateItem(btn.dataset.key, parseInt(btn.dataset.qty));
      });
    });

    body.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateItem(btn.dataset.key, 0);
      });
    });
  }

  /* ── Update Item Quantity ── */
  function updateItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { fetchCart(); });
  }

  /* ── Auto open drawer when item added to cart ── */
  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.btn-atc');
    if (!atcBtn) return;

    var form = atcBtn.closest('form');
    if (!form) return;

    e.preventDefault();

    var formData = new FormData(form);
    var data = {};
    formData.forEach(function (val, key) { data[key] = val; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (res) { return res.json(); })
      .then(function () { openDrawer(); })
      .catch(function (err) { console.error('Add to cart failed', err); });
  });

})();